import React, { useState } from 'react';
import BottomNav from './BottomNav';
import './Auth.css';

const initialActiveBookings = [
  {
    name: 'Amit Sharma',
    status: 'Accepted',
    date: '17th Oct',
    time: '9:00 - 17:00',
    work: 'Welding, Roofing',
    price: 700,
    avatar: 'https://ui-avatars.com/api/?name=Amit+Sharma&background=0074a6&color=fff&size=64',
    actions: ['Cancel Booking', 'Pay Now'],
  },
  {
    name: 'Rahul Singh',
    status: 'Submitted',
    date: '19th Oct',
    time: '9:00 - 17:00',
    work: 'Cleaning, Cooking',
    price: 1200,
    avatar: 'https://ui-avatars.com/api/?name=Rahul+Singh&background=0090d0&color=fff&size=64',
    actions: ['Cancel Booking'],
  },
  {
    name: 'Vikram Yadav',
    status: 'Accepted',
    date: '20th Oct',
    time: '10:00 - 18:00',
    work: 'Painting, Plumbing',
    price: 950,
    avatar: 'https://ui-avatars.com/api/?name=Vikram+Yadav&background=00b4d8&color=fff&size=64',
    actions: ['Cancel Booking', 'Pay Now'],
  },
  {
    name: 'Sandeep Verma',
    status: 'Submitted',
    date: '21st Oct',
    time: '8:00 - 16:00',
    work: 'Gardening, Babysitting',
    price: 800,
    avatar: 'https://ui-avatars.com/api/?name=Sandeep+Verma&background=ffb300&color=fff&size=64',
    actions: ['Cancel Booking'],
  }
];

const expiredBookings = [
  {
    name: 'Vikram Yadav',
    status: 'Cancelled',
    date: '16th Oct',
    time: '9:00 - 17:00',
    work: 'Painting, Plumbing',
    avatar: 'https://ui-avatars.com/api/?name=Vikram+Yadav&background=00b4d8&color=fff&size=64',
    actions: ['Add Review'],
  },
  {
    name: 'Sandeep Verma',
    status: 'Expired',
    date: '16th Oct',
    time: '9:00 - 17:00',
    work: 'Gardening, Babysitting',
    avatar: 'https://ui-avatars.com/api/?name=Sandeep+Verma&background=ffb300&color=fff&size=64',
    actions: ['Add Review'],
  },
  {
    name: 'Amit Sharma',
    status: 'Completed',
    date: '15th Oct',
    time: '9:00 - 17:00',
    work: 'Welding, Roofing',
    avatar: 'https://ui-avatars.com/api/?name=Amit+Sharma&background=0074a6&color=fff&size=64',
    actions: ['Add Review'],
  },
];

const statusColors = {
  Accepted: 'accepted',
  Submitted: 'submitted',
  Cancelled: 'cancelled',
  Completed: 'completed',
  Expired: 'expired',
};

const Booking = () => {
  const [tab, setTab] = useState('active');
  const [activeBookings, setActiveBookings] = useState(initialActiveBookings);
  const [showConfirm, setShowConfirm] = useState(false);
  const [cancelIndex, setCancelIndex] = useState(null);
  const [showReview, setShowReview] = useState(false);
  const [reviewBooking, setReviewBooking] = useState(null);
  const [reviewStars, setReviewStars] = useState(0);
  const [reviewComment, setReviewComment] = useState('');
  const [reviewError, setReviewError] = useState('');
  const [reviewedIndexes, setReviewedIndexes] = useState([]);
  const [reviews, setReviews] = useState([]);
  const bookings = tab === 'active' ? activeBookings : expiredBookings;

  const handleCancelBooking = (index) => {
    setShowConfirm(true);
    setCancelIndex(index);
  };
  const confirmCancel = () => {
    setActiveBookings(prev => prev.filter((_, i) => i !== cancelIndex));
    setShowConfirm(false);
    setCancelIndex(null);
  };
  const closeModal = () => {
    setShowConfirm(false);
    setCancelIndex(null);
  };

  const handleAddReview = (booking) => {
    setReviewBooking(booking);
    setShowReview(true);
    setReviewStars(0);
    setReviewComment('');
    setReviewError('');
  };
  const closeReview = () => {
    setShowReview(false);
    setReviewBooking(null);
    setReviewStars(0);
    setReviewComment('');
    setReviewError('');
  };
  const submitReview = () => {
    if (reviewStars === 0) {
      setReviewError('Please select a star rating.');
      return;
    }
    // Mark this booking as reviewed
    if (reviewBooking) {
      const idx = expiredBookings.findIndex(b => b.name === reviewBooking.name && b.date === reviewBooking.date && b.work === reviewBooking.work);
      if (idx !== -1) setReviewedIndexes(prev => [...prev, idx]);
      setReviews(prev => [
        ...prev,
        {
          name: reviewBooking.name,
          avatar: reviewBooking.avatar,
          work: reviewBooking.work,
          date: reviewBooking.date,
          stars: reviewStars,
          comment: reviewComment,
        }
      ]);
    }
    closeReview();
    alert('Thank you for your review!');
  };

  return (
    <div className="auth-container">
      <div style={{height: 24}}></div>
      <div className="home-section-title" style={{fontSize: 20, marginBottom: 10, textAlign: 'center'}}>
        {tab === 'active' ? 'Active Bookings' : 'Expired Bookings'}
      </div>
      <div className="booking-tabs">
        <button className={`booking-tab${tab==='active' ? ' active' : ''}`} onClick={()=>setTab('active')}>Active</button>
        <button className={`booking-tab${tab==='expired' ? ' active' : ''}`} onClick={()=>setTab('expired')}>Expired</button>
      </div>
      <div className="booking-cards-list">
        {bookings.map((b, i) => (
          <div className="mui-card" key={i}>
            <div className={`booking-card booking-${statusColors[b.status]}`}> 
              <div className="booking-card-header">
                <img src={b.avatar} alt="avatar" className="booking-avatar" />
                <div style={{flex:1}}>
                  <div className="booking-name">{b.name} <span className={`booking-status booking-status-${statusColors[b.status]}`}>{b.status}</span></div>
                  <div className="booking-date">{b.date} | {b.time}</div>
                  <div className="booking-work">Work: {b.work}</div>
                </div>
                {b.price && <div className="booking-price">₹ {b.price}</div>}
              </div>
              <div className="booking-card-actions">
                {b.actions.map((action, idx) => (
                  action === 'Cancel Booking' && tab === 'active' ? (
                    <button key={idx} className={`booking-action-btn booking-action-cancelbooking`} onClick={() => handleCancelBooking(i)}>{action}</button>
                  ) : (
                    action === 'Add Review' && tab === 'expired' && !reviewedIndexes.includes(i) ? (
                      <button key={idx} className={`booking-action-btn booking-action-addreview`} onClick={() => handleAddReview(b)}>{action}</button>
                    ) : (
                      action !== 'Add Review' ? (
                        <button key={idx} className={`booking-action-btn booking-action-${action.replace(/\s/g, '').toLowerCase()}`}>{action}</button>
                      ) : null
                    )
                  )
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {showConfirm && (
        <div className="modal-overlay">
          <div className="modal-content" style={{maxWidth: 320, textAlign: 'center'}}>
            <div style={{fontWeight: 600, fontSize: 17, marginBottom: 16}}>Are you sure you want to cancel this booking?</div>
            <div style={{display: 'flex', gap: 12, justifyContent: 'center'}}>
              <button className="auth-btn" style={{background: '#e74c3c', flex: 1}} onClick={confirmCancel}>Yes</button>
              <button className="auth-btn" style={{background: '#eee', color: '#0074a6', flex: 1}} onClick={closeModal}>No</button>
            </div>
          </div>
        </div>
      )}
      {showReview && (
        <div className="modal-overlay">
          <div className="modal-content" style={{maxWidth: 340, textAlign: 'center', padding: 24}}>
            <div style={{fontWeight: 700, fontSize: 18, marginBottom: 10}}>Add Review</div>
            <div style={{marginBottom: 12}}>
              <div style={{fontWeight: 600, fontSize: 16, marginBottom: 6}}>{reviewBooking?.name}</div>
              <div style={{fontSize: 14, color: '#888', marginBottom: 8}}>{reviewBooking?.work}</div>
              <div style={{display: 'flex', justifyContent: 'center', gap: 4, marginBottom: 8}}>
                {[1,2,3,4,5].map(star => (
                  <span key={star} style={{cursor: 'pointer', fontSize: 28, color: reviewStars >= star ? '#ffc107' : '#ddd'}} onClick={() => setReviewStars(star)}>&#9733;</span>
                ))}
              </div>
              <textarea
                value={reviewComment}
                onChange={e => setReviewComment(e.target.value)}
                placeholder="Write your comments..."
                style={{width: '100%', minHeight: 60, borderRadius: 10, border: '1px solid #eee', padding: 8, fontSize: 15, resize: 'none', marginBottom: 8}}
              />
              {reviewError && <div style={{color: '#e74c3c', fontSize: 14, marginBottom: 6}}>{reviewError}</div>}
            </div>
            <div style={{display: 'flex', gap: 10, marginTop: 8}}>
              <button className="auth-btn" style={{flex: 1}} onClick={submitReview}>Submit</button>
              <button className="auth-btn" style={{background: '#eee', color: '#0074a6', flex: 1}} onClick={closeReview}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      {tab === 'expired' && reviews.length > 0 && (
        <div style={{marginTop: 18, marginLeft: 12}}>
          <div className="home-section-title" style={{fontSize: 17, marginBottom: 10, marginLeft: 6}}>Your Reviews</div>
          {reviews.map((r, i) => (
            <div key={i} className="review-card" style={{display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 14, background: '#f5faff', borderRadius: 12, boxShadow: '0 1px 6px rgba(0,116,166,0.07)', padding: '12px 14px', marginLeft: 6}}>
              <img src={r.avatar} alt="avatar" style={{width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', marginTop: 2}} />
              <div style={{flex: 1}}>
                <div style={{fontWeight: 700, fontSize: 15, color: '#0074a6', marginBottom: 2}}>{r.name}</div>
                <div style={{fontSize: 13, color: '#888', marginBottom: 2}}>{r.work} | {r.date}</div>
                <div style={{display: 'flex', alignItems: 'center', gap: 2, marginBottom: 4}}>
                  {[1,2,3,4,5].map(star => (
                    <span key={star} style={{fontSize: 17, color: r.stars >= star ? '#ffc107' : '#ddd'}}>&#9733;</span>
                  ))}
                </div>
                <div style={{fontSize: 15, color: '#222'}}>{r.comment}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <BottomNav />
    </div>
  );
};

export default Booking; 